export default __webpack_public_path__ + "static/media/1.OFICINA.e9c2e033.jpg";